module.exports = __webpack_public_path__ + "img/offer-detail-bg.d4ad3e44.svg";